import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getGtmBoard,
  getGtmMarketing,
  getGtmContent,
  getGtmHealth,
  classifyIcpFit,
  getContentCalendar,
  draftProposal,
  dismissProposal,
} from '../api/gtm';

export function useGtmBoard(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['gtm', 'board', startDate, endDate],
    queryFn: () => getGtmBoard(startDate, endDate),
    refetchInterval: 300_000,
  });
}

export function useGtmMarketing(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['gtm', 'marketing', startDate, endDate],
    queryFn: () => getGtmMarketing(startDate, endDate),
    refetchInterval: 300_000,
  });
}

export function useGtmContent(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['gtm', 'content', startDate, endDate],
    queryFn: () => getGtmContent(startDate, endDate),
    refetchInterval: 300_000,
  });
}

export function useGtmHealth(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['gtm', 'health', startDate, endDate],
    queryFn: () => getGtmHealth(startDate, endDate),
    refetchInterval: 300_000,
  });
}

export function useClassifyIcpFit() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => classifyIcpFit(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gtm'] });
    },
  });
}

export function useContentCalendar(from: string, to: string) {
  return useQuery({
    queryKey: ['gtm', 'content-calendar', from, to],
    queryFn: () => getContentCalendar(from, to),
    refetchInterval: 300_000,
  });
}

export function useDraftProposal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => draftProposal(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['gtm', 'content-calendar'] }),
  });
}

export function useDismissProposal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => dismissProposal(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['gtm', 'content-calendar'] }),
  });
}
